import React, { useState } from 'react';
import { Search, Bell, ChevronDown, Briefcase, Menu } from 'lucide-react';
import { Input } from '../ui/Input';
import { PersonaId } from '../../App';
interface HeaderProps {
  onNavigate: (page: string, query?: string) => void;
  persona: PersonaId | null;
  onToggleSidebar: () => void;
}
export function Header({
  onNavigate,
  onToggleSidebar
}: HeaderProps) {
  const [globalSearch, setGlobalSearch] = useState('');
  return <header className="h-14 border-b bg-background flex items-center justify-between px-4 md:px-6 sticky top-0 z-10" data-id="element-40">
      <div className="flex items-center space-x-3 flex-1" data-id="element-41">
        {/* Mobile hamburger */}
        <button className="lg:hidden p-2 -ml-1 text-muted-foreground hover:text-foreground rounded-md hover:bg-muted transition-colors" onClick={onToggleSidebar} aria-label="Toggle navigation menu" data-id="element-42">
          <Menu className="w-5 h-5" data-id="element-43" />
        </button>

        <div className="w-64 hidden md:block" data-id="element-44">
          <Input placeholder="Search matters, documents, or concepts..." icon={<Search className="w-4 h-4" data-id="element-46" />} className="bg-muted/50 border-none focus-visible:ring-1 focus-visible:bg-background" value={globalSearch} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalSearch(e.target.value)} onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') {
            const q = globalSearch.trim();
            onNavigate('search', q);
          }
        }} data-id="element-45" />

        </div>

        <div className="h-6 w-px bg-border mx-2 hidden md:block" data-id="element-47"></div>

        <div className="relative group" data-id="element-48">
          <button className="flex items-center space-x-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors py-2" data-id="element-49">
            <Briefcase className="w-4 h-4 mr-1" data-id="element-50" />
            <span className="hidden sm:inline" data-id="element-51">Global Context: All Matters</span>
            <span className="sm:hidden" data-id="element-52">All Matters</span>
            <ChevronDown className="w-4 h-4 ml-1" data-id="element-53" />
          </button>

          {/* Mock Dropdown */}
          <div className="absolute top-full left-0 mt-1 w-64 bg-white border rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50" data-id="element-54">
            <div className="p-2 border-b bg-slate-50" data-id="element-55">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-56">
                Recent Matters
              </p>
            </div>
            <div className="p-1" data-id="element-57">
              <button onClick={() => onNavigate('workspace')} className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 rounded-sm truncate" data-id="element-58">

                <span className="font-medium text-slate-900 block truncate" data-id="element-59">
                  Ramirez v. Lone Star Freight
                </span>
                <span className="text-xs text-slate-500" data-id="element-60">2023-CV-04821</span>
              </button>
              <button onClick={() => onNavigate('workspace')} className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 rounded-sm truncate" data-id="element-61">

                <span className="font-medium text-slate-900 block truncate" data-id="element-62">
                  Castillo v. Westfield Properties
                </span>
                <span className="text-xs text-slate-500" data-id="element-63">2023-CV-05102</span>
              </button>
              <button onClick={() => onNavigate('workspace')} className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 rounded-sm truncate" data-id="element-64">

                <span className="font-medium text-slate-900 block truncate" data-id="element-65">
                  Ortega v. Gulf Coast Industrial
                </span>
                <span className="text-xs text-slate-500" data-id="element-66">2022-CV-03847</span>
              </button>
            </div>
            <div className="p-2 border-t bg-slate-50" data-id="element-67">
              <button onClick={() => onNavigate('matters')} className="w-full text-center text-xs font-medium text-blue-600 hover:text-blue-800" data-id="element-68">

                View All Matters
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-3" data-id="element-69">
        <button className="relative p-2 text-muted-foreground hover:text-foreground rounded-full hover:bg-muted transition-colors" aria-label="Notifications" data-id="element-70">
          <Bell className="w-4 h-4" data-id="element-71" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-destructive rounded-full border-2 border-background" data-id="element-72"></span>
        </button>
        <div className="text-xs font-medium px-2.5 py-1 bg-green-100 text-green-800 rounded-full hidden sm:flex items-center space-x-1" data-id="element-73">
          <span className="w-1.5 h-1.5 bg-green-500 rounded-full" data-id="element-74"></span>
          <span data-id="element-75">Local Node Active</span>
        </div>
      </div>
    </header>;
}